import React from 'react'
import Container from 'react-bootstrap/cjs/Container'
import styled from 'styled-components'

import Card from 'react-bootstrap/cjs/Card'
import { _ } from 'utils'
import AddCrew from './AddCrew'
import CrewOverview from './CrewOverview'

const S = {
    Title: styled.h1`
        margin-bottom: 24px;
    `,
    Description: styled.p`
        font-weight: 300;
        font-size: 16px;
        color: rgba(45, 48, 53, 0.9);
    `,
    SubTitle: styled.h3`
        margin-top: 36px;
        margin-bottom: 24px;
        text-transform: uppercase;
        font-weight: 500;
        font-size: 20px;
    `,
}

const CrewConfig = () => (
    <Container className="my-4 pb-4">
        <S.Title>{_('booth.crew.title')}</S.Title>
        <S.Description>{_('booth.crew.description')}</S.Description>

        <S.SubTitle>{_('booth.crew.add.title')}</S.SubTitle>
        <AddCrew />

        <S.SubTitle>{_('booth.crew.list.title')}</S.SubTitle>
        <Card>
            <CrewOverview />
        </Card>
    </Container>
)

export default CrewConfig
